import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-level-up',
  templateUrl: 'level-up.html',
})
export class LevelUpPage {

  levelName: string;
  levelImage: string;

  constructor(private navParams: NavParams, private navCtrl: NavController) {
  }

  ionViewWillLoad() {
    this.levelName = this.navParams.get('levelName');
    this.levelImage = this.navParams.get('levelImage');
  }

  goBack() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/modules/core/pages/level-up/level-up.ts